import { mediaQueries } from './mediaQueries';
import { useMatchMedia } from './useMatchMedia';
export function useScreenSm() {
  return useMatchMedia(mediaQueries.screens.sm);
}